(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sorting"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll('.sorting-filter__input')
      .forEach((input) => {
        input.addEventListener('change', () => {
          if (input.form) {
            input.form.submit();
          }
        });
      });
  });
  } catch(e) { console.error(e); }
})();

})();
